import { translate } from "app/language/service"
import React from "react"
import { IGeoShapeCountry } from "shape/model"
import { getCountryName, searchCountries } from "shape/tools/common"
import { EntitiesSelect } from "ui/components/EntitiesSelect"

interface ICountrySelectProps {
  id?: string
  defaultCountries?: IGeoShapeCountry[]
  onChange: (countries: IGeoShapeCountry[]) => any
}

export const CountrySelect = React.memo(
  ({ id, defaultCountries, onChange }: ICountrySelectProps): JSX.Element => (
    <EntitiesSelect
      id={id || "country-select"}
      defaultSelectedEntities={defaultCountries}
      idKey="country_shape_id"
      inputLabel={translate("report.group.sort.by.country")}
      inputPlaceholder={translate("label.search.name")}
      getOptionLabel={(country: any) => getCountryName(country)}
      onChange={countries => onChange(countries as IGeoShapeCountry[])}
      searchEntities={filter => searchCountries(filter)}
    />
  )
)
